'use strict';
budgetAnalysisController.$inject = ['$scope', '$q', '$interval', 'dialogHelper', 'reportHelper', 'unitService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('budgetAnalysisController', budgetAnalysisController);

function budgetAnalysisController($scope, $q, $interval, dialogHelper, reportHelper, unitService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.load($scope.vm)]);

	function getViewModel() {
		var model = {
			message: BUSY_MESSAGE.Loading,
			report: {
				fiscalYear: {},
				fiscalMonthFrom: null,
				fiscalMonthTo: null,
				thirteenthMonth: true,
				excludeZeroBalanceAccounts: true,
				summaryOnly: false,
				lockFundAsFirstElement: false,
				groupBy: 'none',
				groupings: null,
			},
			fundElement: '',
			fiscalMonths: [],
			fiscalYears: [],
			validationErrors: [],
			errors: null,
		};

		function groupByChanged(model) {
			if (model.report.groupBy === model.fundElement) {
				model.report.groupings[0].lockFundAsFirstElement = true;

				// if the first element in the groupings is not the Fund element
				// then we'll wipe out the groupings and create a new one with the Fund element as the first element
				let fundIndex = _.findIndex(model.report.groupings[0].elementsMinMaxList, function (obj) {
					return obj.ElementName === model.fundElement;
				});
				let rowOne = model.report.groupings[0].rangeRows[0];

				if (rowOne.ElementIndex !== fundIndex) {
					model.report.groupings[0].rangeRows = [{}];
					let dElement = _.find(model.report.groupings[0].elementsMinMaxList, function (obj) {
						return obj.ElementName === model.fundElement;
					});
					let row = {
						ElementIndex: fundIndex,
						RangeOption: 'range',
						FromValue: dElement.MinValue,
						ToValue: dElement.MaxValue,
						SubTotal: true,
					};
					model.report.groupings[0].rangeRows[0] = row;
				}
			} else model.report.groupings[0].lockFundAsFirstElement = false;
		}

		function validateReportParams(model) {
			model.validationErrors = [];
			var isValid = true;

			if (!model.report.fiscalYear) {
				model.validationErrors.push('Please select a valid Fiscal Year.');
				isValid = false;
			}

			if (!model.report.fiscalMonthFrom) {
				model.validationErrors.push("Please select a valid 'From' month.");
				isValid = false;
			}

			if (!model.report.fiscalMonthTo) {
				model.validationErrors.push("Please select a valid 'To' month.");
				isValid = false;
			}

			let fyStartmonth = moment(model.report.fiscalYear.FYStartDT).format('MM');
			let dateFrom = null;
			let dateTo = null;

			if (model.report.fiscalMonthFrom < fyStartmonth) {
				dateFrom = model.report.fiscalMonthFrom + '/01/' + moment(model.report.fiscalYear.FYEndDT).format('YYYY');
			} else {
				dateFrom = model.report.fiscalMonthFrom + '/01/' + moment(model.report.fiscalYear.FYStartDT).format('YYYY');
			}
			if (model.report.fiscalMonthTo < fyStartmonth) {
				dateTo = model.report.fiscalMonthTo + '/01/' + moment(model.report.fiscalYear.FYEndDT).format('YYYY');
			} else {
				dateTo = model.report.fiscalMonthTo + '/01/' + moment(model.report.fiscalYear.FYStartDT).format('YYYY');
			}

			if (isValid === true && moment(dateFrom, 'MM-DD-YYYY').startOf('day') > moment(dateTo, 'MM-DD-YYYY').startOf('day')) {
				model.validationErrors.push('To month cannot occur before From month');
				isValid = false;
			}

			if (model.report.groupBy === 'none' || model.report.groupBy === model.fundElement) {
				angular.forEach(model.report.groupings, function (g) {
					angular.forEach(g.rangeRows, function (r) {
						if (isValid === true) {
							if (r.ElementIndex === null || r.ElementIndex.length === 0) {
								model.validationErrors.push('One or more rows is missing a selected Element!');
								isValid = false;
							}
							if (r.FromValue === undefined || r.FromValue === null || r.FromValue.length === 0) {
								model.validationErrors.push("One or more rows is missing a 'From' Value!");
								isValid = false;
							}
							if (r.RangeOption === 'range') {
								if (r.ToValue === undefined || r.ToValue === null || r.ToValue.length === 0) {
									model.validationErrors.push("One or more rows is missing a 'To' Value!");
									isValid = false;
								}
							}
						}
					});
				});
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Budget Analysis Report Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var GroupCol = [];
			if (model.report.groupBy === 'none' || model.report.groupBy === model.fundElement) {
				angular.forEach(model.report.groupings, function (g) {
					angular.forEach(g.rangeRows, function (r) {
						var gItem = {
							ElementName: g.elementsMinMaxList[r.ElementIndex].ElementName,
							FilterBy: r.RangeOption,
							FromValue: String(r.FromValue) || '0',
							ToValue: String(r.ToValue) || '0',
							SubTotal: r.SubTotal,
							PageBreak: r.PageBreak,
						};
						if (r.RangeOption === 'equals') {
							gItem.ToValue = String(r.FromValue) || '0';
						}
						GroupCol.push(gItem);
					});
				});
			}

			var report = {
				FiscalYear: model.report.fiscalYear.FiscalYear || 0,
				FiscalMonthFrom: model.report.fiscalMonthFrom || 0,
				FiscalMonthTo: model.report.fiscalMonthTo || 0,
				ThirteenthMonth: model.report.thirteenthMonth,
				ExcludeZeroBalanceAccounts: model.report.excludeZeroBalanceAccounts,
				SummaryOnly: model.report.summaryOnly,
				GroupBy: model.report.groupBy,
				BudgetAnalysisGroupCol: GroupCol,
			};

			reportHelper.postReport($scope, '/api/fundreports/budgetanalysisreport', report, 'BudgetAnalysisReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Budget Analysis Report Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var GroupCol = [];

			if (model.report.groupBy === 'none' || model.report.groupBy === model.fundElement) {
				angular.forEach(model.report.groupings, function (g) {
					angular.forEach(g.rangeRows, function (r) {
						var gItem = {
							ElementName: g.elementsMinMaxList[r.ElementIndex].ElementName,
							FilterBy: r.RangeOption,
							FromValue: String(r.FromValue) || '0',
							ToValue: String(r.ToValue) || '0',
							SubTotal: r.SubTotal,
							PageBreak: r.PageBreak,
						};
						if (r.RangeOption === 'equals') {
							gItem.ToValue = String(r.FromValue) || '0';
						}
						GroupCol.push(gItem);
					});
				});
			}

			var report = {
				FiscalYear: model.report.fiscalYear.FiscalYear || 0,
				FiscalMonthFrom: model.report.fiscalMonthFrom || 0,
				FiscalMonthTo: model.report.fiscalMonthTo || 0,
				ThirteenthMonth: model.report.thirteenthMonth,
				ExcludeZeroBalanceAccounts: model.report.excludeZeroBalanceAccounts,
				SummaryOnly: model.report.summaryOnly,
				GroupBy: model.report.groupBy,
				BudgetAnalysisGroupCol: GroupCol,
			};

			reportHelper.postExcel($scope, '/api/fundreports/budgetanalysisexcel', report, 'BudgetAnalysis.xlsx');
		}

		function load(model) {
			return unitService.getUnit().then(_.partial(finishLoadingUnit, model));

			function finishLoadingUnit(model, response) {
				model.fundElement = response.data.unit.FundElement;

				return unitService.getFiscalYearsWithDates().then(_.partial(finishLoadingYears, model));
			}

			function finishLoadingYears(model, response) {
				model.fiscalYears = response.data.fiscalYears;

				return unitService.getFiscalMonths().then(_.partial(finishLoadingMonths, model));
			}

			function finishLoadingMonths(model, response) {
				var arrMonths = response.data.fiscalMonths;
				angular.forEach(arrMonths, function (m) {
					var obj = { Id: 0, Description: m };
					switch (m) {
						case 'January':
							obj.Id = 1;
							break;
						case 'February':
							obj.Id = 2;
							break;
						case 'March':
							obj.Id = 3;
							break;
						case 'April':
							obj.Id = 4;
							break;
						case 'May':
							obj.Id = 5;
							break;
						case 'June':
							obj.Id = 6;
							break;
						case 'July':
							obj.Id = 7;
							break;
						case 'August':
							obj.Id = 8;
							break;
						case 'September':
							obj.Id = 9;
							break;
						case 'October':
							obj.Id = 10;
							break;
						case 'November':
							obj.Id = 11;
							break;
						case 'December':
							obj.Id = 12;
							break;
					}
					model.fiscalMonths.push(obj);
				});

				return finishLoadingDefaults(model);
			}

			function finishLoadingDefaults(model) {
				var currentFY = _.find(model.fiscalYears, function (obj) {
					return obj.FiscalYear === obj.CurrentFY;
				});

				model.report.fiscalYear = currentFY;

				var monthStart = moment(currentFY.FYStartDT).format('MM');
				var monthEnd = moment(currentFY.FYEndDT).format('MM');

				model.report.fiscalMonthFrom = parseInt(monthStart);
				model.report.fiscalMonthTo = parseInt(monthEnd);
				return angular.noop;
			}
		}

		return angular.extend(model, {
			groupByChanged: _.partial(groupByChanged, model),
			load: _.partial(load, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}

angular.module('schoolLinqApp').directive('budgetAnalysisElementRange', [
	'$q',
	'accountStructureService',
	'accountService',
	function ($q, accountStructureService, accountService) {
		return {
			require: ['ngModel'],
			scope: {
				ngModel: '=',
			},
			replace: true,
			restrict: 'AE',
			template: require('@ajs/templates/reports/budgetAnalysisElementRange.html'),
			controller: [
				'$scope',
				'$element',
				'$rootScope',
				function ($scope, $element, $rootScope) {
					$scope.viewModel = {
						unifiedFundMask: null,
						unifiedFundElementIndex: null,
						revenueElementMap: null,
						expenseElementMap: null,
						elements: [],
						fundElement: '',
					};

					$scope.ngModel = [
						{
							lockFundAsFirstElement: false,
							elementsMinMaxList: [],
							rangeRows: [{}],
						},
					];

					$scope.loadingElementRange = $q.all([loadAccountStructures()]);

					function loadAccountStructures() {
						return accountStructureService.getStructure().then(finishLoadingAccountStructures);

						function finishLoadingAccountStructures(response) {
							$scope.viewModel.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
							$scope.viewModel.unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;

							var arrElements = [];

							if (response.data.accountStructure.UnifiedElementMap !== null) {
								arrElements = response.data.accountStructure.UnifiedElementMap.split('.');

								$scope.viewModel.fundElement = response.data.accountStructure.UnifiedElementMap.split('.')[
									response.data.accountStructure.UnifiedElementFundIndex
								];
							} else {
								$scope.viewModel.expenseElementMap = response.data.accountStructure.ExpenseElementMap;
								$scope.viewModel.revenueElementMap = response.data.accountStructure.RevenueElementMap;
								let revenueElements = response.data.accountStructure.RevenueElementMap.split('.');
								let expenseElements = response.data.accountStructure.ExpenseElementMap.split('.');

								arrElements = _.union(revenueElements, expenseElements);

								// get the Fund name (just get it from the Asset Element Map since it will be the same for all the types)
								$scope.viewModel.fundElement = response.data.accountStructure.AssetElementMap.split('.')[
									response.data.accountStructure.AssetElementFundIndex
								];
							}

							//Build Elements
							var idx = 0;
							angular.forEach(arrElements, function (e) {
								$scope.viewModel.elements.push({
									Index: idx,
									Id: e,
									Description: e,
									MinValue: '',
									MaxValue: '',
									PlaceHolder: '',
								});
								idx++;
							});

							return accountService.getElementsMinMax(arrElements).then(finishLoadingElementMinMax);
						}

						function finishLoadingElementMinMax(response) {
							$scope.ngModel[0].elementsMinMaxList = response.data.elementsMinMaxList;

							angular.forEach($scope.ngModel[0].elementsMinMaxList, function (e) {
								var elementItem = _.find($scope.viewModel.elements, function (obj) {
									return obj.Id === e.ElementName;
								});
								if (elementItem) {
									elementItem.MinValue = e.MinValue;
									elementItem.MaxValue = e.MaxValue;

									for (var i = 0; i < e.MaxValue.length; i++) {
										elementItem.PlaceHolder += '_';
									}
								}
							});

							let fundIndex = _.findIndex($scope.ngModel[0].elementsMinMaxList, function (obj) {
								return obj.ElementName === $scope.viewModel.fundElement;
							});
							let dElement = _.find($scope.ngModel[0].elementsMinMaxList, function (obj) {
								return obj.ElementName === $scope.viewModel.fundElement;
							});

							var row = {
								ElementIndex: fundIndex,
								RangeOption: 'range',
								FromValue: dElement.MinValue,
								ToValue: dElement.MaxValue,
								SubTotal: true,
							};
							$scope.ngModel[0].rangeRows[0] = row;

							return angular.noop;
						}
					}

					$scope.rangeOptions = [
						{
							displayName: 'range',
							filter: 'range',
						},
						{
							displayName: 'equals',
							filter: 'equals',
						},
					];

					$scope.addRow = function (filter) {
						filter.rangeRows.push({
							ElementIndex: '',
							RangeOption: 'range',
							SubTotal: true,
						});
					};

					$scope.removeRow = function (filter, row) {
						let index = _.findIndex(filter.rangeRows, {
							$$hashKey: row.$$hashKey,
						});
						filter.rangeRows.splice(index, 1);
					};

					$scope.moveRowUp = function (filter, row) {
						let index = _.findIndex(filter.rangeRows, {
							$$hashKey: row.$$hashKey,
						});
						//get the row to move down
						var rowToMoveDown = filter.rangeRows[index - 1];
						filter.rangeRows.splice(index - 1, 1);
						filter.rangeRows.splice(index, 0, rowToMoveDown);
					};

					$scope.moveRowDown = function (filter, row) {
						let index = _.findIndex(filter.rangeRows, {
							$$hashKey: row.$$hashKey,
						});
						//get the row to move up
						var rowToMoveUp = filter.rangeRows[index + 1];
						filter.rangeRows.splice(index + 1, 1);
						filter.rangeRows.splice(index, 0, rowToMoveUp);
					};
				},
			],
		};
	},
]);
